define([
    "dojo/_base/declare",
    "csi/table/Widget"
], function(declare,Widget) {

    return declare(Widget, {
    	// C8-749: Colorway BO view to select colorway keys - enable ad-hoc filtering on Attribute Name in "Go to..." dialog
    	bSupportsQuerySettings: true 
    });
});